import { API } from 'widget/helpers/axios';

// DEPRECATED: We should never create carts from the backend
// export const createStorefrontCart = async (conversationId, items = []) => {
//   const url = `/api/v1/widget/conversations/cart/create${window.location.search}`;
//   return API.post(url, { items });
// };

// Uses token authentication from window.location.search, not conversation ID
export const syncAjaxToken = async (conversationId, ajaxToken) => {
  const url = `/api/v1/widget/conversations/cart/sync${window.location.search}`;
  return API.post(url, { ajax_token: ajaxToken });
};

export const getCartInfo = async (conversationId) => {
  const url = `/api/v1/widget/conversations/cart${window.location.search}`;
  return API.get(url);
};